<div class="toasts">
  @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      [class]="toast.classname"
      [autohide]="toast.autoHide ?? true"
      [delay]="toast.delay ?? 5000"
      [header]="toast.header ?? ''"
      (hide)="toastService.remove(toast)"
    >
      @if (isTemplate(toast)) {
        <ng-template [ngTemplateOutlet]="toast.textOrTpl" />
      } @else {
        @if (toast.error) {
          @if (toast.message) {
            <p> {{ toast.message }}</p>
          }
          @if (toast.requestId) {
            <p> requestId: {{ toast.requestId }}</p>
          }
        } @else {
          {{ toast.textOrTpl }}
        }
      }
    </ngb-toast>
  }
</div>
